import React, { useState } from 'react';
import { Row, Col, Carousel } from 'react-bootstrap';

import { PlayerPopup } from '../../../components'
import PrincipalItem from './itemsCarousel/PricipalItem/PrincipalItem';
import SecondaryItem from './itemsCarousel/SecondaryItem/SecondaryItem';

import './sectionCarousel.css'


function LlegoCarousel() {
  const [showVideo, setShowVideo] = useState(false);
  const [source, setSource] = useState('');
  const [index, setIndex] = useState(0);

  const handleSelect = (selectedIndex) => {
    setIndex(selectedIndex);
  };

  const openPlayer = (open, path) => {
    setSource(`${process.env.REACT_APP_VIDEOS_CDN_URL}${path}`)
    setShowVideo(open)
  }

  return (
    <React.Fragment>
      {
        showVideo &&
        <PlayerPopup
          close={() => openPlayer(false)}
          show={showVideo}
          source={source}
        />
      }
      <div id="llegoClaro" className="llegoclaro">
        <Row className="content-section space-top-title">
          <Col>
            <h1 className="main-text">¡Lleg&oacute; Claro Pay!</h1>
            <div className="desc-text">
              La app que te permite recibir y enviar dinero, <br />
              recargar tiempo aire, pagar en comercios y mucho más.<br />
              Todo esto gratis y al instante desde tu celular.
            </div>
          </Col>
        </Row>
        <Row>
          <Col>
            <div className="section-content-carousel">
              <Carousel activeIndex={index} onSelect={handleSelect} slide={true} indicators={false}>
                <Carousel.Item className="slide first">
                  <PrincipalItem onClick={() => openPlayer(true, '/ClaroPay_Que_es.mp4')} />
                </Carousel.Item>
                <Carousel.Item className="slide">
                  <SecondaryItem
                    title="Ya puedes enviar dinero a tus seres queridos."
                    image="slide-envia"
                    buttonText="Ver tutorial"
                    background="green"
                    onClick={() => openPlayer(true, '/Dinero/enviarDineroweb.mp4')}
                  >
                    <p>¿Necesitas enviar dinero lo más rápido posible a tu mamá o a tu hijo que vive en otra ciudad?</p>
                    <p>En un instante pueden recibirlo, envíalo desde la app Claro Pay.</p>
                  </SecondaryItem>
                </Carousel.Item>
                <Carousel.Item className="slide third">
                  <SecondaryItem
                    title="Olvídate de las filas."
                    subtitle="Paga tus servicios desde el celular."
                    image="slide-paga-servicio"
                    buttonText="Ver tutorial"
                    background="yellow"
                    onClick={() => openPlayer(true, '/servicios/pagarServiciosWeb.mp4')}
                  >
                    <p>Con Claro Pay puedes pagar el agua, luz, gas, televisión, internet y muchos servicios más. También puedes programar pagos automáticos para que nunca se te vuelva a olvidar hacer algún pago.</p>
                  </SecondaryItem>
                </Carousel.Item>
                <Carousel.Item className="slide fourth">
                  <SecondaryItem
                    title="¡No te quedes sin saldo!"
                    subtitle="Recarga tiempo aire desde tu celular."
                    image="slide-recarga"
                    buttonText="Ver tutorial"
                    background="blue"
                    onClick={() => openPlayer(true, '/consulta/consultaSaldoWeb.mp4')}
                  >
                    <p>Con la app Claro Pay, puedes adquirir tiempo aire para cualquier compañía. Recarga a partir de $10 pesos desde donde estés.</p>
                  </SecondaryItem>
                </Carousel.Item>
                <Carousel.Item className="slide third">
                  <SecondaryItem
                    title='No más "solo efectivo".'
                    subtitle="¡Paga lo que se te antoje con el celular!"
                    image="slide-paga-comercio"
                    buttonText="Ver tutorial"
                    background="yellow"
                    onClick={() => openPlayer(true, '/comercios/pagarComerciosWeb.mp4')}
                  >
                    <p> Sí, porque con Claro Pay ahora podrás pagar en tus comercios favoritos de forma rápida y segura mediante un código QR. Además, podrás enviar dinero a cualquier persona solo con su número celular.</p>
                  </SecondaryItem>
                </Carousel.Item>
                <Carousel.Item className="slide second">
                  <SecondaryItem
                    title='¡Ya puedes recibir y retirar dinero con tu celular!'
                    image="slide-recibe"
                    buttonText="Ver tutorial"
                    background="green"
                    onClick={() => openPlayer(true, '/Dinero/retirarDinero.mp4')}
                  >
                    <p> Sí, porque con Claro Pay ahora podrás pagar en tus comercios favoritos de forma rápida y segura mediante un código QR. Además, podrás enviar dinero a cualquier persona solo con su número celular.</p>
                  </SecondaryItem>
                </Carousel.Item>
              </Carousel>
            </div>
          </Col>
        </Row>

      </div>
    </React.Fragment >
  )
}

export default LlegoCarousel;